'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_React$Component) {
	_inherits(Toggle, _React$Component);

	function Toggle() {
		_classCallCheck(this, Toggle);

		return _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).apply(this, arguments));
	}

	_createClass(Toggle, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    className = _props.className,
			    checked = _props.checked,
			    props = _objectWithoutProperties(_props, ['className', 'checked']);

			return _react2.default.createElement(_reactBootstrap.Checkbox, _extends({
				inline: true,
				className: (0, _classnames2.default)('axui toggle', className, { checked: checked }),
				checked: checked
			}, props));
		}
	}]);

	return Toggle;
}(_react2.default.Component);

Toggle.propTypes = {
	/**
  * The class name to apply to the toggle.
  */
	className: _propTypes2.default.string,

	/**
  * Controls the checked state of the toggle.
  */
	checked: _propTypes2.default.bool,

	/**
  * Disables toggle.
  */
	disabled: _propTypes2.default.bool,

	/**
  * Title of toggle
  */
	title: _propTypes2.default.string,

	/**
  * Style of toggle
  */
	style: _propTypes2.default.object,

	/**
   	 * Attaches a ref to the `<input>` element. Only functions can be used here.
   	 *
   	 * ```js
   	 * <Toggle inputRef={ref => { this.input = ref; }} />
   	 * ```
   	 */
	inputRef: _propTypes2.default.func,

	/**
  * Callback
  */
	onChange: _propTypes2.default.func
};

Toggle.defaultProps = {
	title: '',
	className: '',
	checked: false,
	disabled: false
};

var _default = Toggle;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Toggle, 'Toggle', 'src/components/Toggle.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/Toggle.jsx');
}();

;